import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { decodeJwt } from 'jose';

export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const token = localStorage.getItem('token');

  // Both tokens go, always: the refresh token alone buys a fresh access token
  // with the same roles for 30 days, so half a cleanup is no cleanup.
  const toLogin = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('roleIds');
    localStorage.removeItem('mustRotate');
    localStorage.removeItem('orgContext');
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  };

  if (!token) {
    return toLogin();
  }

  try {
    const payload: any = decodeJwt(token);
    const now = Math.floor(Date.now() / 1000);
    // An expired access token is not an expired session: the refresh token
    // lives 30 days. Let the route open — the first API call 401s and the
    // interceptor refreshes.
    if (payload.exp && payload.exp < now && !localStorage.getItem('refreshToken')) {
      return toLogin();
    }
    return true;
  } catch (e) {
    return toLogin();
  }
};
